"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummarizedAggregateError = void 0;
class SummarizedAggregateError extends AggregateError {
    constructor(errors, message) {
        super(errors, message ??
            `${errors.length} Errors:\n${errors
                .map((e) => (typeof e === 'object' && e !== null && 'message' in e ? e.message : e))
                .filter(Boolean)
                .join('\n')}`);
        this.errors = errors;
        Object.setPrototypeOf(this, SummarizedAggregateError.prototype);
    }
}
exports.SummarizedAggregateError = SummarizedAggregateError;
//# sourceMappingURL=summarized-aggregate-error.js.map